"use client"
import Image from "next/image";
import Link from 'next/link';
import logo from '@/app/assets/icons/assistant_logo.svg';
import { useUserSession } from "@/app/lib/context/UserSessionContext";

export default function Logo({ text = "AI", styleClass = "" }) {
    const { sessionInfo } = useUserSession();
    const link = sessionInfo?.userType === 'designer' ? '/designer' : '/supplier';
    return (
        <div className={`flex items-end ml-[30px] ${styleClass}`}>
            <Link href={link} className="flex items-end">
                <Image
                    className="pt-[10px]"
                    src={logo}
                    alt="logo"
                    height={48}
                    priority
                />
                {/* <div className="text-[25px] ml-[5px] font-lora">{text}</div> */}
            </Link>
        </div>
    )
}